const SESSION_PRESENTATION = Object.freeze({
  overnight: Object.freeze({
    session: 'overnight',
    label: 'Overnight',
    textClass: 'text-violet-400',
    mutedTextClass: 'text-violet-400/80',
    color: '#A855F7',
    isExtended: true,
  }),
  pre: Object.freeze({
    session: 'pre',
    label: 'Pre-market',
    textClass: 'text-orange-400',
    mutedTextClass: 'text-orange-400/80',
    color: '#F59E0B',
    isExtended: true,
  }),
  post: Object.freeze({
    session: 'post',
    label: 'Post-market',
    textClass: 'text-blue-400',
    mutedTextClass: 'text-blue-400/80',
    color: '#3B82F6',
    isExtended: true,
  }),
})

export function quoteSessionPresentation(session) {
  return SESSION_PRESENTATION[String(session || '').trim().toLowerCase()] || null
}

export function buildQuoteSessionPriceLine(price, session) {
  const value = Number(price)
  const presentation = quoteSessionPresentation(session)
  if (!presentation || !Number.isFinite(value) || value <= 0) return null
  return {
    price: value,
    color: presentation.color,
    lineWidth: 1,
    lineStyle: 2,
    axisLabelVisible: true,
    title: presentation.label,
  }
}
